










import TableCell from './TableCell.vue'
import OrderId from './order-common/OrderId.vue'

export default {
  components: {
    TableCell,
    OrderId
  },
  props: {
    orderId: { type: String, required: true },
    orderIsCanceled: { type: Boolean, default: false },
    orderIsNew: { type: Boolean, default: false }
  }
}
